const ConfirmationPage = () => {
  return (
    <div>
      <h1>Contact Form Submitted</h1>
      <p>Thank you for reaching out to us. Your message has been successfully sent.</p>
      <p>We will get back to you as soon as possible.</p>
    </div>
  );
};

export default ConfirmationPage;
